import moment from "moment";

export const IDENTITY_MANUAL_FALLBACK_REASONS = [
  "document_not_found",
  "document_already_registered",
  "kyc_unavailable",
  "rate_limit_exceeded",
];

export const parseNationalIdType = nationalID => {
  if (!nationalID || typeof nationalID !== "string") return null;
  const [prefix] = nationalID.split("-");
  if (prefix === "V" || prefix === "E" || prefix === "RUT") return prefix;
  return null;
};

export const buildNationalID = (idType, nationalId) => {
  if (idType === "RUT") {
    const clean = normalizeChileanRUT(nationalId);
    const body = clean.slice(0, -1);
    const dv = clean.slice(-1);
    return `RUT-${body}-${dv}`;
  }
  const digits = String(nationalId).replace(/\D/g, "");
  return `${idType}-${digits}`;
};

export const normalizeChileanRUT = rut => (rut || "").replace(/[^0-9kK]/g, "").toUpperCase();

export const validateChileanRUT = rut => {
  if (!rut) return false;
  const cleanRUT = normalizeChileanRUT(rut);
  if (!/^\d{7,8}[0-9K]$/.test(cleanRUT)) return false;

  const body = cleanRUT.slice(0, -1);
  const providedDv = cleanRUT.slice(-1);
  let sum = 0;
  let multiplier = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += Number.parseInt(body[i], 10) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }
  const remainder = 11 - (sum % 11);
  let expectedDv;
  if (remainder === 11) expectedDv = "0";
  else if (remainder === 10) expectedDv = "K";
  else expectedDv = String(remainder);
  return providedDv === expectedDv;
};

export const formatBirthdate = dateValue => {
  if (!dateValue) return "";
  if (typeof dateValue === "string") return dateValue.split("T")[0];
  if (dateValue.toDate) return moment(dateValue.toDate()).format("YYYY-MM-DD");
  return moment(dateValue).format("YYYY-MM-DD");
};

export const isAdultFromBirthdate = birthdate => {
  const formatted = formatBirthdate(birthdate);
  if (!formatted) return false;
  return moment().diff(moment(formatted, "YYYY-MM-DD"), "years") >= 18;
};

export const isIdentityManualFallback = ({data, errorCode} = {}) => {
  if (errorCode && IDENTITY_MANUAL_FALLBACK_REASONS.includes(errorCode)) {
    return true;
  }
  if (data?.rejection_reason && IDENTITY_MANUAL_FALLBACK_REASONS.includes(data.rejection_reason)) {
    return true;
  }
  return false;
};

export const isIdentityUnderage = data => {
  if (data?.is_adult === false) return true;
  if (data?.rejection_reason === "underage") return true;
  if (data?.birth_date && !isAdultFromBirthdate(data.birth_date)) return true;
  return false;
};
